<script setup lang="ts">
import { storeToRefs } from 'pinia'

import Diets from './Diets.vue'
import MetaPreparation from './MetaPreparation.vue'
import RecipeRating from './RecipeRating.vue'
import { useConfigStore } from '../../../stores/config'

import type { RecipeParagraph } from '../../../utils/paragraph-schema/paragraphs'
import type { ComposedPageMeta } from '@xcel-next/composer-schema'

defineProps<{
  recipe?: RecipeParagraph['recipe'],
  pageMeta?: ComposedPageMeta
}>()

const { rsConfig } = storeToRefs(useConfigStore())
</script>

<template>
  <div class="bx-content bx-recipe__meta">
    <RecipeRating v-if="rsConfig.userArea?.enableRecipeRating"
                  :page-meta="pageMeta" />
    <div>
      <MetaPreparation :cooking-time="recipe?.cookingTime"
                       :difficulty="recipe?.difficultyText" />
      <Diets v-if="recipe?.dietaryConsiderations"
             :diets="recipe.dietaryConsiderations" />
    </div>
  </div>
</template>
